module.exports = __webpack_public_path__ + "img/close.ee5252f9.png";